import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FileService, SupportDataService } from '../../_services'
import { IStoreDocument, ITag } from '../../_entities';
import { FileBase } from './file-base';

@Component({
	selector: 'file-documents',
	template: require('./document.component.html')
})
export class DocumentComponent extends FileBase {

	constructor(
		private fileService: FileService,
		private supportData: SupportDataService) {
		super();
		this.tags = this.supportData.getDocumentTags();
	}

	tags: Promise<ITag[]>;

	@Input() enableUpload: boolean = false;

	@Input() portletColor: string;

	@Input() uploadUrl: string;

	@Input() files: IStoreDocument[];

	@Input() tag: string;

	@Output('onUploaded') onUploadedCallback = new EventEmitter();

	@Output('onDeleted') onDeletedCallback = new EventEmitter();

	@Output('onChange') onChangeCallback = new EventEmitter();

	confirmDelete(id, event) {
		if (this.files.find(x => x.id === id)) {
			this.fileService.deleteFile(id).then(() => {
				this.onDeletedCallback.emit(id);
			});
		}
	}

	onChange(id, event) {
		this.onChangeCallback.emit({ id, event });
	}

}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/file/document.component.ts